import { Component } from "@angular/core";
import { BreadcrumbService } from "../services/breadcrumb.service";
import { Observable } from "rxjs";
import { Breadcrumb } from "../interfaces/breadcrumb.interface";

@Component({
  selector: "gnl-bread-crumb",
  templateUrl: "./bread-crumb.component.html",
  styleUrls: ["./bread-crumb.component.scss"],
})
export class BreadCrumbComponent {
  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs;
  }
}
